import { useEffect, useState } from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useLead } from "@/components/public/LeadDialog";
import ContactEnquiry, { DEFAULT_SPACE_TYPES, DEFAULT_CITIES, DEFAULT_SEATS } from "@/components/public/ContactEnquiry";
import { Txt } from "@/components/public/AboutSections";

export const CONTACT_DEFAULTS = {
  eyebrow: "Contact Us",
  title: "Let's Find Your Perfect Workspace",
  subtitle: "Reach out and our team will help you choose the right space for your team.",
  cta_title: "Prefer to talk?",
  cta_subtitle: "Book a tour or request a custom quote and we'll get back to you shortly.",
  form: {
    space_type_label: "Select Space Type",
    space_types: DEFAULT_SPACE_TYPES,
    name_label: "Full Name", name_placeholder: "Type your full name here",
    mobile_label: "Mobile", mobile_placeholder: "Type your mobile number here",
    email_label: "Email", email_placeholder: "Type your email here",
    city_label: "City", city_placeholder: "Select City", cities: DEFAULT_CITIES,
    seats_label: "Number of seats", seats: DEFAULT_SEATS,
    consent: "", submit_label: "Submit",
  },
};

export function withContactDefaults(content) {
  const c = content || {};
  const f = c.form || {};
  const d = CONTACT_DEFAULTS;
  return {
    ...d,
    ...c,
    form: {
      ...d.form,
      ...f,
      space_types: f.space_types && f.space_types.length ? f.space_types : d.form.space_types,
      cities: f.cities && f.cities.length ? f.cities : d.form.cities,
      seats: f.seats && f.seats.length ? f.seats : d.form.seats,
    },
  };
}

export default function ContactSections({ data, edit }) {
  const { openLead } = useLead();
  const [settings, setSettings] = useState({});
  useEffect(() => { api.get("/public/homepage").then((r) => setSettings(r.data.settings)).catch(() => {}); }, []);
  return (
    <>
      <ContactEnquiry content={data} edit={edit} />
      <div className="container-cz py-16 grid lg:grid-cols-2 gap-12" data-testid="contact-info">
        <div>
          <Txt edit={edit} path="eyebrow" value={data.eyebrow} as="p" className="eyebrow mb-3 inline-block" placeholder="Eyebrow" />
          <Txt edit={edit} path="title" value={data.title} as="h1" className="block font-display text-4xl sm:text-5xl font-extrabold text-slate-900" placeholder="Title" />
          <Txt edit={edit} path="subtitle" value={data.subtitle} as="p" className="text-lg text-slate-600 mt-5" placeholder="Subtitle" />
          <div className="space-y-3 mt-8 text-slate-700">
            <p className="flex items-center gap-3"><MapPin className="w-5 h-5 text-primary" /> {settings.address}</p>
            <p className="flex items-center gap-3"><Phone className="w-5 h-5 text-primary" /> {settings.phone}</p>
            <p className="flex items-center gap-3"><Mail className="w-5 h-5 text-primary" /> {settings.email}</p>
          </div>
        </div>
        <div className="card-cz p-8 flex flex-col justify-center gap-4">
          <Txt edit={edit} path="cta_title" value={data.cta_title} as="h2" className="block font-display text-2xl font-bold text-slate-900" placeholder="CTA title" />
          <Txt edit={edit} path="cta_subtitle" value={data.cta_subtitle} as="p" className="text-slate-600" placeholder="CTA subtitle" />
          <div className="flex flex-wrap gap-3 mt-2">
            <Button onClick={() => openLead("tour")} className="rounded-full h-12 px-7">Book a Tour</Button>
            <Button onClick={() => openLead("quote")} variant="outline" className="rounded-full h-12 px-7 border-slate-300">Get a Quote</Button>
          </div>
        </div>
      </div>
    </>
  );
}
